import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '../../../public/images/gambeat_logo_black_full.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  class: "q-mr-auto",
  src: _imports_0,
  width: "120",
  height: "24"
}, null, -1)
const _hoisted_2 = {
  key: 0,
  class: "header__lang self-stretch flex items-center header_border"
}
const _hoisted_3 = { style: {"margin-left":"32px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ChangeLang = _resolveComponent("ChangeLang")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_header = _resolveComponent("q-header")!

  return (_openBlock(), _createBlock(_component_q_header, {
    class: "top-bottom-panel header",
    reveal: _ctx.$q.screen.width >= 1440
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_q_toolbar, { class: "header__top flex" }, {
          default: _withCtx(() => [
            _hoisted_1,
            (_ctx.$q.screen.width >= 1025)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(_component_ChangeLang)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_q_btn, {
                label: "Log in",
                unelevated: "",
                "no-caps": "",
                outline: "",
                color: "primary",
                class: "q-btn__main-size text-weight-bold q-mr-sm",
                to: "/login"
              }),
              _createVNode(_component_q_btn, {
                label: "Sign up",
                unelevated: "",
                "no-caps": "",
                color: "primary",
                class: "q-btn__main-size text-weight-bold",
                "icon-right": _ctx.heroOutline24Plus,
                to: "/sign-up"
              }, null, 8, ["icon-right"])
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["reveal"]))
}